export default [
  {
    path: "/error-404",
    name: "error-404",
    component: () => import("@/views/error/Error404.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/main-dashboard",
    name: "main-dashboard",
    component: () => import("@/views/MainDashboard/MainDashboard.vue"),
  },
  {
    path: "/users/preview/:id",
    name: "users-preview",
    component: () => import("@/views/Users/UserPermissions.vue"),
  },
  {
    path: "/users",
    name: "users",
    component: () => import("@/views/Users/Users.vue"),
  },
  {
    path: "/users/add",
    name: "add-users",
    component: () => import("@/views/Users/AddNewUser.vue"),
  },
  {
    path: "/country",
    name: "country",
    component: () => import("@/views/HIS/Country.vue"),
  },
  {
    path: "/city",
    name: "city",
    component: () => import("@/views/HIS/City.vue"),
  },
  {
    path: "/governorate",
    name: "governorate",
    component: () => import("@/views/HIS/Governorate.vue"),
  },
  {
    path: "/Job/title",
    name: "job-title",
    component: () => import("@/views/HIS/JobTitle.vue"),
  },
  {
    path: "/profile",
    name: "user-profile",
    component: () => import("@/views/Users/UserProfile.vue"),
  },
];
